import classNames from 'classnames';
import React from 'react';

import {ContainerSummary} from 'constants/SampleConstants';
import * as InventoryUnitUtil from 'inventory/InventoryUnitUtil';
import getQuantityDisplayString from 'samples/getQuantityDisplayString';
import {ConfirmTransferQuantitiesData} from 'samples/transfers/TransferModalUtil';
import {
  getLegacyMeasurementString,
  getQuantitiesForTransferValidation,
  getTransferQuantitiesFromConfirmTransferQuantitiesData,
  getTransferQuantityValidationText,
} from 'samples/transfers/TransferUtil';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

interface InputContainerQuantityChangeProps {
  inputContainer: ContainerSummary;
  confirmTransferQuantitiesData: ConfirmTransferQuantitiesData;
}

export default function InputContainerQuantityChange({
  inputContainer,
  confirmTransferQuantitiesData,
}: InputContainerQuantityChangeProps): JSX.Element {
  if (inputContainer.quantity.value == null) {
    return (
      <div className="legacy-font-proxima-13">
        Source container has untracked {getQuantityDisplayString(false, false)}.
      </div>
    );
  }

  const hasAllUntrackedTransfers = confirmTransferQuantitiesData.every(
    (data) => data.outputContainer.quantity.units == null
  );
  if (hasAllUntrackedTransfers) {
    return (
      <div className="legacy-font-proxima-13">
        No transfer {getQuantityDisplayString(false, true)} are specified.
      </div>
    );
  }

  const hasIncompatibleUnitsInTransfers = !InventoryUnitUtil.areUnitsCompatibleFromSymbols([
    inputContainer.quantity.units,
    ...confirmTransferQuantitiesData.map((data) => data.outputContainer.quantity.units),
  ]);
  const {
    remainingQuantity,
    totalTransferQuantity,
    isValid: transferQuantitiesAreValid,
    quantityErrorsAreBlocking,
  } = getQuantitiesForTransferValidation(
    inputContainer.quantity,
    getTransferQuantitiesFromConfirmTransferQuantitiesData(confirmTransferQuantitiesData)
  );

  return (
    <div className="legacy-font-proxima-13">
      <span className="inputContainerQuantityChange-text">
        {`Total ${getQuantityDisplayString(false, false)} to be removed from ${inputContainer.barcode}: ` +
          `${hasIncompatibleUnitsInTransfers ? 'N/A' : getLegacyMeasurementString(totalTransferQuantity)} `}
      </span>
      <span
        className={classNames('inputContainerQuantityChange-subtext', {
          'inputContainerQuantityChange-subtext--warning': !transferQuantitiesAreValid,
        })}
      >
        {`(${getLegacyMeasurementString(remainingQuantity)} remaining)`}
      </span>
      {!transferQuantitiesAreValid && (
        <div className="u-small-spacing-top">
          <InlineBanner
            bannerType={quantityErrorsAreBlocking ? InlineBannerType.ERROR : InlineBannerType.WARNING}
            text={getTransferQuantityValidationText(inputContainer, quantityErrorsAreBlocking)}
          />
        </div>
      )}
    </div>
  );
}
